export default "__VITE_ASSET__CEvUsWwy__"